var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.097 0L0 2.12 6.806 9 0 15.88 2.097 18 11 9z","fillRule":"nonzero"}));
}

ArrowRight.defaultProps = {"fill":"currentColor","viewBox":"0 0 11 18"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
